import {
  CLEAR_TOURNMENT_DATA,
  CREATE_TOURNAMENT_ERROR,
  CREATE_TOURNAMENT_LOADING,
  CREATE_TOURNAMENT_SUCCESS,
  GET_A_TOURNAMENT_LIST_ERROR,
  GET_A_TOURNAMENT_LIST_LOADING,
  GET_A_TOURNAMENT_LIST_SUCCESS,
  GET_ONE_TOURNAMENT_ERROR,
  GET_ONE_TOURNAMENT_LOADING,
  GET_ONE_TOURNAMENT_SUCCESS,
  TOURNAMENTS_LIST_ERROR,
  TOURNAMENTS_LIST_LOADING,
  TOURNAMENTS_LIST_SUCCESS,
  UPDATE_PLAYER_STATUS_ERROR,
  UPDATE_PLAYER_STATUS_LOADING,
  UPDATE_PLAYER_STATUS_SUCCESS,
} from "../../../constant/actionTypes";
import { apiGet, apiPut } from "../../../utils/apiRequests";
import ApiEndpoints from "../../../utils/ApiEndpoints";

export const listAllTournaments = () => (dispatch) => {
  dispatch({ type: TOURNAMENTS_LIST_LOADING });

  apiGet(
    `${ApiEndpoints.tournament.base}${ApiEndpoints.tournament.poty}`,
    (response) => {
      if (response.error === true) {
        dispatch({ type: TOURNAMENTS_LIST_ERROR, response: response.message });
        console.log("err", response.error);
      } else {
        dispatch({ type: TOURNAMENTS_LIST_SUCCESS, response: response });
        // console.log("get tournaments response ===>>>>", response);
      }
    },
    (error) => {
      console.log("error ===>>>>", error);
      dispatch({ type: TOURNAMENTS_LIST_ERROR, response: error });
    }
  );
};

export const createPOTYTournament = (data) => (dispatch) => {
  dispatch({ type: CREATE_TOURNAMENT_LOADING });
  apiPut(
    `${ApiEndpoints.tournament.base}${ApiEndpoints.tournament.add}`,
    data,
    (response) => {
      // console.log("submit tornsment response ....", response);

      if (response.error === true) {
        dispatch({
          type: CREATE_TOURNAMENT_ERROR,
          response: response.message,
        });
      } else {
        dispatch({ type: CREATE_TOURNAMENT_SUCCESS, response: response });
        localStorage.setItem("tournamentID", response.tournament_id);
      }
    },
    (error) => {
      console.log("error ===>>>>", error);
      dispatch({ type: CREATE_TOURNAMENT_ERROR, response: error });
    }
  );
};

export const getPOTYTournamentById = (id) => (dispatch) => {
  dispatch({ type: GET_ONE_TOURNAMENT_LOADING });
  apiGet(
    `${ApiEndpoints.tournament.base}${ApiEndpoints.tournament.poty}${ApiEndpoints.tournament.getPOTYDetails}${id}`,
    (response) => {
      // console.log("submit tornsment response ....", response);

      if (response.error === true) {
        dispatch({
          type: GET_ONE_TOURNAMENT_ERROR,
          response: response.message,
        });
      } else {
        dispatch({ type: GET_ONE_TOURNAMENT_SUCCESS, response: response });
      }
    },
    (error) => {
      console.log("error ===>>>>", error);
      dispatch({ type: GET_ONE_TOURNAMENT_ERROR, response: error });
    }
  );
};

export const clearPOTYTournament = () => (dispatch) => {
  dispatch({
    type: CLEAR_TOURNMENT_DATA,
  });
};

export const updatePlayerStatus = (data, id) => (dispatch) => {
  dispatch({ type: UPDATE_PLAYER_STATUS_LOADING });
  apiPut(
    `${ApiEndpoints.tournament.base}${ApiEndpoints.tournament.poty}${ApiEndpoints.tournament.update}${id}`,
    data,
    (response) => {
      // console.log(" PLAYER STATUS response ....", response);

      if (response.error === true) {
        dispatch({
          type: UPDATE_PLAYER_STATUS_ERROR,
          response: response.message,
        });
      } else {
        dispatch({ type: UPDATE_PLAYER_STATUS_SUCCESS, response: response });
        // localStorage.setItem("tournamentID", response.tournament_id);
      }
    },
    (error) => {
      console.log("error ===>>>>", error);
      dispatch({ type: UPDATE_PLAYER_STATUS_ERROR, response: error });
    }
  );
};

export const getAllPotyTournaments = () => (dispatch) => {
  dispatch({ type: TOURNAMENTS_LIST_LOADING });

  apiGet(
    `${ApiEndpoints.tournament.getAllPoty}`,
    (response) => {
      if (response.error === true) {
        dispatch({ type: TOURNAMENTS_LIST_ERROR, response: response.message });
        console.log("err", response.error);
      } else {
        dispatch({ type: TOURNAMENTS_LIST_SUCCESS, response: response });
      }
    },
    (error) => {
      console.log("error ===>>>>", error);
      dispatch({ type: TOURNAMENTS_LIST_ERROR, response: error });
    }
  );
};

export const getOnePotyTournament = (id) => (dispatch) => {
  dispatch({ type: GET_A_TOURNAMENT_LIST_LOADING });

  apiGet(
    `${ApiEndpoints.tournament.getOnePoty}${id}`,
    (response) => {
      if (response.error === true) {
        dispatch({
          type: GET_A_TOURNAMENT_LIST_ERROR,
          response: response.message,
        });
        console.log("err", response.error);
      } else {
        dispatch({ type: GET_A_TOURNAMENT_LIST_SUCCESS, response: response });
        // console.log("get tournaments response ===>>>>", response);
      }
    },
    (error) => {
      console.log("error ===>>>>", error);
      dispatch({ type: GET_A_TOURNAMENT_LIST_ERROR, response: error });
    }
  );
};
